module.exports = __webpack_public_path__ + "img/empty-projects.f4f6d9b8.svg";